// Polyfills
import 'core-js/stable'
import 'regenerator-runtime/runtime'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import { ColorThemePlugin } from '../services/vuestic-ui'
import store from '../store/index'
import router from '../router/index'
import { VuesticPlugin } from '../services/vuestic-ui/components'
import '../i18n/index'
import YmapPlugin from 'vue-yandex-maps'
import VueClipboard from 'vue-clipboard2'
import axios from 'axios'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
// import VueSignalR from '@latelier/vue-signalr'
import VueSignalR from '@onreal/vue-signalr'
import VueHtmlToPaper from 'vue-html-to-paper'
import '../metrics'
// import '../registerServiceWorker'
import WebCam from 'vue-web-cam'
// import { HttpTransportType } from '@aspnet/signalr'
import GAuth from 'vue-google-oauth2'
import VCalendar from 'v-calendar'

if (store.getters.isLoggedIn && store.getters.theTimezone) {
  moment.tz.setDefault(store.getters.theTimezone.zoneName)
}

if (process.env.VUE_APP_BUILD_VERSION) {
  // eslint-disable-next-line
  const message = `%c${'Build_information:'}\n %c${'Version'}: %c${VERSION},\n %c${'Timestamp'}: %c${TIMESTAMP},\n %c${'Commit'}: %c${COMMIT}`
}

Vue.prototype.$http = axios
axios.defaults.baseURL = process.env.VUE_APP_API_URL
axios.interceptors.response.use((response) => {
  return response
}, function (error) {
  const originalRequest = error.config
  if (error.response.status === 401 && !originalRequest._retry) {
    store.commit('logout')
    router.push({ name: 'login' })
  }
  if (error.response.status === 403 && !originalRequest._retry) {
    store.commit('logout')
    router.push({ name: 'login' })
  }
  // Do something with response error
  return Promise.reject(error)
})

if (store.getters.isLoggedIn) {
  localStorage.setItem('scope', 'https://www.googleapis.com/auth/cloudprint')
} else {
  localStorage.setItem('scope', 'profile email')
}

const gauthOption = {
  clientId: '89954126654-jsdmijmj275bgsu0baf1kb6f5hvdu39j.apps.googleusercontent.com',
  scope: localStorage.getItem('scope'),
  prompt: 'consent',
}

Vue.use(GAuth, gauthOption)
Vue.use(WebCam)
Vue.use(VuesticPlugin)
Vue.use(YmapPlugin)
Vue.use(VueClipboard)
Vue.use(VueMoment, {
  moment,
})
Vue.use(VCalendar, {})

const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes',
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css',
  ],
}
Vue.use(VueHtmlToPaper, options)

Vue.use(ColorThemePlugin, {
  // override colors here.
})
Vue.use(VueSignalR, process.env.VUE_APP_SOCKET_URL + '/progressHub')
router.beforeEach((to, from, next) => {
  store.commit('setLoading', true)
  next()
})

router.afterEach((to, from) => {
  store.commit('setLoading', false)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
  created () {
    // if (this.$store.getters.isLoggedIn) {
    //   this.$socket.start({
    //     log: false,
    //     skipNegotiation: true,
    //     transport: HttpTransportType.WebSockets,
    //   })
    // }
  },
})
